/**
 * Timer Component
 * Displays a countdown timer with visual warning states
 */
import { Timer as TimerIcon, AlertCircle } from "lucide-react";
import { cn } from "../lib/utils";

export default function Timer({
  timeRemaining,
  maxTime,
  isChallenge = false,
  className
}) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const isLowTime = timeRemaining <= 30;
  const isCritical = timeRemaining <= 10;
  const percentRemaining = (timeRemaining / maxTime) * 100;

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div 
        className={cn(
          "flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-mono font-medium transition-colors",
          isCritical 
            ? "bg-destructive/20 text-destructive animate-pulse" 
            : isLowTime 
              ? "bg-amber-500/20 text-amber-600 dark:text-amber-400"
              : isChallenge
                ? "bg-secondary/20 text-secondary"
                : "bg-primary/20 text-primary"
        )}
      >
        {isCritical ? (
          <AlertCircle className="w-4 h-4" />
        ) : (
          <TimerIcon className="w-4 h-4" />
        )}
        <span data-testid="timer-display">{formatTime(timeRemaining)}</span>
      </div>
      
      {/* Progress indicator */}
      <div className="w-20 h-1.5 bg-muted rounded-full overflow-hidden hidden sm:block">
        <div 
          className={cn(
            "h-full transition-all duration-1000 rounded-full",
            isCritical 
              ? "bg-destructive" 
              : isLowTime 
                ? "bg-amber-500"
                : isChallenge
                  ? "bg-secondary"
                  : "bg-primary"
          )}
          style={{ width: `${percentRemaining}%` }}
        />
      </div>
    </div>
  );
}
